import React from "react";
import PropTypes from "prop-types";
import { HISTORIC_GUARDIAN_BOND } from "../historicGuardianConfig";
import HistoricGuardianFormBase from "./HistoricGuardianFormBase";
import GoogleAutoComplete from "./ProbateHistoricGoogleAutoComplete";
import LabeledCreatableSelect from "./ProbateHistoricLabeledCreatableSelect";
import { scrollToTop } from "../../../../features/bonds/shared/formHelpers";

export default function ProbateHistoricGuardianForm(props) {
  return (
    <HistoricGuardianFormBase
      bondKind={HISTORIC_GUARDIAN_BOND.probate}
      GoogleAutoComplete={GoogleAutoComplete}
      LabeledCreatableSelect={LabeledCreatableSelect}
      scrollToTop={scrollToTop}
      {...props}
    />
  );
}

ProbateHistoricGuardianForm.propTypes = {
  data: PropTypes.shape({ guardians: PropTypes.array }),
  updateData: PropTypes.func.isRequired,
  globalData: PropTypes.object.isRequired,
  errors: PropTypes.object,
};
